import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


const routesSettings = require('../../routes.json');

const INIT_VALUES =  {
    layerDetail: null,
    locales: routesSettings.languages,
    locale: routesSettings.defaultLanguage,
    hrefLangLocales: routesSettings.hrefLangLocales,
    languageSwitcher: routesSettings.languageSwitcher,
    localePrefixes: routesSettings.prefixes,
    noMultilanguagePages: routesSettings.noMultilanguagePages
};

const mutations = {
    setLayerDetailData(state, data) {
        state.layerDetail = data;
    },
    SET_LANG(state, locale) {
        if (state.locales.indexOf(locale) !== -1) {
            state.locale = locale
        }
    }
}


import UI from './modules/ui';
import AuthModule from './modules/auth';
import BasketModule from './modules/basket';

const store = new Vuex.Store({
    state: { ...INIT_VALUES },
    mutations: mutations,
    actions: {},
    modules: {
        ui: UI,
        auth: AuthModule,
        basket: BasketModule
    }
});

console.log('***** VUEX STORE *****', store.state);

export default store;
